module.exports = __webpack_public_path__ + "media/images/footer/pl_rp-b9dd0ea22f922137556cf5e4c1e93339.svg";